import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import CommonInputTwo from "../CommonForms/CommonInputTwo";
import { Col, Row } from "antd";
import classes from "./Filter.module.css";
import { lengths } from "../../Shared/Constants";
import {
  CatchMessage,
  FilterValuesCheck,
  JSONtoformdata,
  Phone_Number_Validation,
  tokenisValid,
  TrimStart,
  ValidinputData,
} from "../../Shared/Methods";
import CommonButton from "../Buttons/CommonButton";
import Commonselectfield from "../CommonForms/CommonSelectField";
import { deviceDropdown, meterDropdown } from "../../Services/ApiServices";
import { HandleSessionModal } from "../../Store/Redux/Reducers/Authreducers";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { handleloading } from "../../Store/Redux/Reducers/Dashboardreducers";

interface props {
  showfilter: boolean;
  pageSize: number;
  pageind: number;
  GetList: (page: number, size: number, values: any) => void;
  setpageSize: Dispatch<SetStateAction<number>>;
  setPageInd: Dispatch<SetStateAction<number>>;
  ResetForm: () => void;
}

function FilterMailSettings({
  showfilter,
  pageSize,
  pageind,
  GetList,
  setpageSize,
  setPageInd,
  ResetForm,
}: props) {
  const [values, setvalues] = useState({
    meter_id: null,
    device_id: null,
  });
  const dispatch = useDispatch();
  const { LoginData } = useSelector((state: any) => state.Auth);
  const [deviceList, setDeviceList] = useState<any>([]);
  const [meterList, setMeterList] = useState<any>([]);
  const handleDeviceDropDown = () => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      user_id: LoginData?.userId,
    };

    deviceDropdown(JSONtoformdata(finalObj))
      .then(async (res) => {
        if (res.data.status === 1) {
          const device = res.data.data.map((ele: any, ind: number) => {
            return { value: ele?.deviceId, label: ele?.deviceName };
          });
          setDeviceList(device);
        } else if (res.data.status === -1) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res.data.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res.data.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  console.log("login", LoginData);

  useEffect(() => {
    if (LoginData !== null) {
      handleDeviceDropDown();
    }
  }, [LoginData]);

  useEffect(() => {
    if (values?.device_id) {
      handleMeterDropDown(values?.device_id);
    } else {
      setvalues({
        ...values,
        meter_id: null,
      });
    }
  }, [values?.device_id]);

  const handleMeterDropDown = (values: any) => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      device_id: values,
    };

    meterDropdown(JSONtoformdata(finalObj))
      .then(async (res) => {
        if (res.data.status === 1) {
          const meter = res.data.data.map((ele: any, ind: number) => {
            return { value: ele?.id, label: ele?.meter_name };
          });
          setMeterList(meter);
        } else if (res.data.status === -1) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res.data.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res.data.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  return (
    <>
      {showfilter ? (
        <div className={classes.filter_container}>
          <Row gutter={[16, 16]}>
            <Col xl={6} lg={8} md={8} sm={12} xs={24}>
              <Commonselectfield
                labelname="Device"
                value={values.device_id}
                onChange={(value) => {
                  setvalues({
                    ...values,
                    device_id: value,
                  });
                }}
                style={{ width: "100%" }}
                options={deviceList}
                size="large"
              />
            </Col>
            <Col xl={6} lg={8} md={8} sm={12} xs={24}>
              <Commonselectfield
                labelname="Meter"
                value={values.meter_id}
                onChange={(value) => {
                  console.log("values", value);
                  setvalues({
                    ...values,
                    meter_id: value,
                  });
                }}
                style={{ width: "100%" }}
                options={meterList}
                size="large"
                disabled={values?.device_id ? false : true}
              />
            </Col>

            <Col
              xl={6}
              lg={8}
              md={8}
              sm={12}
              xs={24}
              className="d-flex align-items-end"
            >
              <CommonButton
                name="Search"
                onClick={() => GetList(1, pageSize, values)}
                type="Submit"
                classname="submit_btn"
                disabled={FilterValuesCheck(values)}
              />
              &nbsp;&nbsp;
              <CommonButton
                name="Reset"
                onClick={() => {
                  setvalues({ meter_id: null, device_id: null });
                  ResetForm();
                }}
                // style={{ color: "white", backgroundColor: "#0084ff" }}
                type="button"
                classname="reset_btn"
                disabled={FilterValuesCheck(values)}
              />
            </Col>
          </Row>
        </div>
      ) : null}
    </>
  );
}

export default FilterMailSettings;
